import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import MainLayout from '../layouts/MainLayout';
import axios from '../lib/axios';
import {GetStaticPropsContext} from 'next';
import {ContentContainer} from '@interfaces/content-container';
import {APIRequestConfig} from '@enums/request-config';
import HeadMeta from '@components/Header/HeadMeta';
import {localizeHtmlEnglishLinks} from '@lib/localize-html-links';
import {useRouter} from 'next/router';

interface HomePageProps {
  data: ContentContainer;
}
export default function Homepage({data}: HomePageProps) {
  const router = useRouter();
  const locale = router.locale;
  return (
    <MainLayout>
      <HeadMeta
        title={data['seo_page_title']}
        description={data['seo_description']}
        keywords={data['seo_keywords']}
        canonical_url={data['canonical_url']}
      />
      <div className="">
        <div className="container-xxl">
          {data.contents.map((content, index) => {
            return (
              <section
                className={`${content.div_container} ${content.columns}`}
                key={index}
              >
                {content.columns === 3 && (
                  <div
                    className={`${content['div_1_classnames']} 3`}
                    dangerouslySetInnerHTML={{
                      __html: localizeHtmlEnglishLinks(
                        content['column_div_1']!,
                        locale
                      ),
                    }}
                  ></div>
                )}

                {content.columns >= 2 && (
                  <div
                    className={`${content['div_2_classnames']} 2`}
                    dangerouslySetInnerHTML={{
                      __html: localizeHtmlEnglishLinks(
                        content['column_div_2']!,
                        locale
                      ),
                    }}
                  ></div>
                )}
                {content.columns >= 1 && (
                  <div
                    className={`${content['div_3_classnames']} 1`}
                    dangerouslySetInnerHTML={{
                      __html: localizeHtmlEnglishLinks(
                        content['column_div_3'],
                        locale
                      ),
                    }}
                  ></div>
                )}
              </section>
            );
          })}
        </div>
      </div>
    </MainLayout>
  );
}

export async function getStaticProps({locale}: GetStaticPropsContext) {
  const response = await axios.get<any>('pages/homepage', {
    headers: {[APIRequestConfig.X_LOCALE]: locale!},
  });
  return {
    props: {
      data: response.data.data,
      ...(await serverSideTranslations(locale!, ['common'])),
    },
  };
}
